import { addClass, removeClass, hasClass } from '../../../../core/utils/src/dom';
var DROP_UP_CLASS = 'awsui-select-dropdown-drop-up';
var AVAILABLE_SPACE_RESERVE = 50;
export var getOverflowParents = function (element) {
    var parents = [];
    while ((element = element.parentElement)) {
        getComputedStyle(element).overflow !== 'visible' && parents.push(element);
    }
    parents.push(window);
    return parents;
};
export var saveContainersScrollPosition = function (element, ignoredContainer) {
    return getOverflowParents(element)
        .filter(function (parentContainer) { return parentContainer !== ignoredContainer; })
        .map(function (parentContainer) {
        return {
            parentContainer: parentContainer,
            scrollTop: parentContainer.scrollTop
        };
    });
};
// `focus` method causes scrolling in Safari
// to prevent this we need to restore the previous scroll position
// of all the parent containers with overflow !== visible
// see more details on https://issues.amazon.com/issues/AWSUI-7290
// https://github.com/calvellido/focus-options-polyfill/blob/master/index.js
export var restoreContainersScrollPosition = function (savedScrollPositions) {
    // Hijacking the event loop order, since the focus() will internally
    // trigger scrolling that goes to the event loop
    window.setTimeout(function () {
        savedScrollPositions.forEach(function (_a) {
            var parentContainer = _a.parentContainer, scrollTop = _a.scrollTop;
            if (parentContainer.scrollTop !== scrollTop) {
                parentContainer.scrollTop = scrollTop;
            }
        });
    }, 0);
};
var DropdownFitHandler = /** @class */ (function () {
    function DropdownFitHandler(dropdown, requestItems) {
        var _this = this;
        this.dropdown = dropdown;
        this.requestItems = requestItems;
        var trigger = dropdown.offsetParent.querySelector('.awsui-dropdown-trigger');
        var filter = dropdown.querySelector('[awsui-select-dropdown-region="filter"]');
        var filterHeight = filter ? filter.offsetHeight : 0;
        this.optionsContainer = dropdown.querySelector('.awsui-select-dropdown-options-container');
        var overflowParents = getOverflowParents(dropdown);
        var minimumAvailableSpace = overflowParents.reduce(function (_a, overflowParent) {
            var above = _a.above, below = _a.below;
            var availableSpace = _this.getAvailableSpace(overflowParent, trigger, filterHeight);
            return {
                above: Math.min(above, availableSpace.above),
                below: Math.min(below, availableSpace.below)
            };
        }, { above: Number.MAX_VALUE, below: Number.MAX_VALUE });
        this.availableSpaceAbove = minimumAvailableSpace.above;
        this.availableSpaceBelow = minimumAvailableSpace.below;
    }
    DropdownFitHandler.prototype.getAvailableSpace = function (parent, trigger, filterHeight) {
        var parentOffset = parent && parent.getBoundingClientRect ? parent.getBoundingClientRect() : { top: 0, height: window.innerHeight };
        var offsetTop = trigger.getBoundingClientRect().bottom - parentOffset.top;
        return {
            above: offsetTop - trigger.offsetHeight - filterHeight - AVAILABLE_SPACE_RESERVE,
            below: parentOffset.height - offsetTop - filterHeight - AVAILABLE_SPACE_RESERVE
        };
    };
    DropdownFitHandler.prototype.dropUp = function () {
        addClass(this.dropdown, DROP_UP_CLASS);
    };
    DropdownFitHandler.prototype.dropDown = function () {
        removeClass(this.dropdown, DROP_UP_CLASS);
    };
    DropdownFitHandler.prototype.isDroppedUp = function () {
        return hasClass(this.dropdown, DROP_UP_CLASS);
    };
    DropdownFitHandler.prototype.setMaxHeight = function (maxHeight) {
        if (!this.optionsContainer) {
            return;
        }
        this.optionsContainer.style.maxHeight = maxHeight + "px";
    };
    DropdownFitHandler.prototype.fitDropdown = function () {
        // Save old scrolling position
        var beforeScrollTop = this.optionsContainer.scrollTop;
        var beforeDroppedUp = this.isDroppedUp();
        // The dropdown container knows the true height of the dropdown.
        // If it does not exist here, use offsetHeight of the dropdown HTMLElement
        var dropdownContainer = this.optionsContainer.children[0];
        var dropdownHeight = dropdownContainer ? dropdownContainer.scrollHeight : this.dropdown.offsetHeight;
        // try to expand the dropdown downwards first, if that's not possible put it where more space is
        if (this.availableSpaceBelow < dropdownHeight && this.availableSpaceBelow < this.availableSpaceAbove) {
            this.dropUp();
        }
        var maxAvailableSpace = Math.max(this.availableSpaceAbove, this.availableSpaceBelow);
        if (maxAvailableSpace <= dropdownHeight) {
            this.setMaxHeight(Math.max(0, maxAvailableSpace));
        }
        else {
            this.requestItems();
        }
        // Reapply old scrolling position if possible
        if (beforeDroppedUp === this.isDroppedUp()) {
            this.optionsContainer.scrollTop = beforeScrollTop;
        }
    };
    return DropdownFitHandler;
}());
var fitDropdown = function (dropdown, requestItems) {
    if (!dropdown.offsetParent) {
        return;
    }
    var dropdownFitHandler = new DropdownFitHandler(dropdown, requestItems);
    dropdownFitHandler.fitDropdown();
};
export default fitDropdown;
//# sourceMappingURL=dropdown-fit-handler.js.map